module.exports = __webpack_public_path__ + "img/why-championla_image5.f6606edb.jpg";